import { atom } from 'nanostores'

import { UNIVERSAL_MOBILE_LINK } from './constants/links'

export const isModalOpen = atom(false)

export function openDialog() {
  if (window?.matchMedia('only screen and (max-width: 600px)').matches) {
    window.open(UNIVERSAL_MOBILE_LINK, '_blank', 'noopener,noreferrer')
    return
  }

  isModalOpen.set(true)
}

export function closeDialog() {
  isModalOpen.set(false)
}
